import styled from "@emotion/styled";
import { AbsoluteLink, Avatar, Box, FlexRow, H3, Stack, Text } from "atoms";
import { PublicProfile, User } from "features/auth";
import { UserStatus } from "./UserStatus";

type UserCardProps = {
  user: User | PublicProfile;
};

function UserCard({ user }: UserCardProps) {
  return (
    <UserCardElement>
      <AbsoluteLink to={`/users/${user.id}`}>{user.name}</AbsoluteLink>
      <FlexRow gap="10px">
        <Avatar src={user.avatar?.url300 || user.avatar?.url} size="3em" />
        <Stack gap="xxs">
          <UserName size="sm">{user.name}</UserName>
          <Status size="xxs">{UserStatus(user)}</Status>
        </Stack>
      </FlexRow>
    </UserCardElement>
  );
}

const UserCardElement = styled(Box)(({ theme }) => ({
  padding: "1rem",
  position: "relative",
}));

const UserName = styled(H3)(({ theme }) => ({
  "&&": { margin: 0 },
}));
const Status = styled(Text)(({ theme }) => ({
  margin: 0,
}));

export { UserCard };
